import { render, staticRenderFns } from "./overviewRateLimitsBox.vue?vue&type=template&id=610b72c6&"
import script from "./overviewRateLimitsBox.vue?vue&type=script&lang=ts&"
export * from "./overviewRateLimitsBox.vue?vue&type=script&lang=ts&"
import style0 from "./overviewRateLimitsBox.vue?vue&type=style&index=0&id=610b72c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports